module.exports = __webpack_public_path__ + "media/components/assets/upcycling_01-8bf97c788f142ddf60a57bb436ec3721.jpg";